export default {
  // eslint-disable-next-line no-useless-escape
  ort: /^[^0-9!§$%&=?#*+{\[\]}]*$/,
  telefon: /^\+?(?:[0-9][\s-/]*){4,}$/
};
